import { Box, Flex, Text } from '@shared/components';
import type { PropsWithOptionalChildren } from '@shared/utils';

import { UserTypeAvatar } from '../../../containers/user-type-avatar';
import type { UserAvatarData } from '../../types';

interface UserAvatarAndEmailProps extends PropsWithOptionalChildren<UserAvatarData> {
  firstName: string;
  lastName: string;
  email: string;
}

export function UserAvatarAndEmail(props: Readonly<UserAvatarAndEmailProps>) {
  const { firstName, lastName, email, profilePic } = props;

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(3) }}>
      <UserTypeAvatar fullName={`${firstName} ${lastName}`} email={email} src={profilePic} />
      <Box>
        <Text variant='body1Semibold'>
          {firstName} {lastName}
        </Text>
        <Text variant='body2' color='text.secondary'>
          {email}
        </Text>
      </Box>
    </Flex>
  );
}
